module.exports = __webpack_public_path__ + "img/Certificate.2428b140.svg";